import api from "./api";

// 训练营列表
export const postOperationLog = params => {
  return api('post', `/v1/management/operation-log`, params);
};
